import { Platform } from "react-native";

export function toClipPathUrl(id: string) {
  if (Platform.OS === "web") {
    return `url(#${id})`;
  } else {
    return `#${id}`;
  }
}
